/* global  */ // tUrl等のグローバル変数を宣言する

// import './_form.js'

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// 最小サイズ
const bpTab = 821
const bpTabWide = 1024
const bpPC = 1200

$('.js-fixedAppDL-close').on('click', function () {
  $('.js-fixedAppDL').hide()
})

/*
########  #######  ########
   ##    ##     ## ##     ##
   ##    ##     ## ########
   ##    ##     ## ##
   ##     #######  ##
*/
/*
        ########  ########   #######  ########  ##     ##  ###### ########
        ##     ## ##     ## ##     ## ##     ## ##     ## ##         ##
####### ########  ########  ##     ## ##     ## ##     ## ##         ##
        ##        ##   ##   ##     ## ##     ## ##     ## ##         ##
        ##        ##     ##  #######  ########   #######   ######    ##
*/
// TOP製品画像
if ($('.js-topProduct')[0]) {
  const imgHeight = $('.js-topProduct-img').height()
  const productContainer = $('.js-topProduct')
  // const triggerTop = $('.js-topProduct-intro').offset().top
  // const triggerBottom = $('.js-topProduct-detail').offset().top

  let headerHeight = 60
  // let paddingTop = 500
  // let paddingBottom = 265
  let paddingTop = productContainer.offset().top + $('.js-topProduct-intro').offset().top
  let paddingBottom =
    productContainer.offset().top +
    productContainer.height() -
    $('.js-topProduct-detail').offset().top +
    $('.js-topProduct-detail').height()
  if (window.matchMedia('(min-width:' + bpTab + 'px)').matches) {
    //タブレット以上
    paddingTop = 500
    paddingBottom = 265
  }
  if (window.matchMedia('(min-width:' + bpTabWide + 'px)').matches) {
    //タブレット横置き以上
    headerHeight = 77
    paddingTop = 120
    paddingBottom = 265
  }
  if (window.matchMedia('(min-width:' + bpPC + 'px)').matches) {
    //PC以上
    headerHeight = 100
    // paddingTop = 120
    // paddingBottom = 265
  }
  let topProduct = productContainer.offset().top - headerHeight + paddingTop + 60
  let bottomProduct = topProduct + imgHeight
  // let topProduct = triggerTop + imgHeight
  // let bottomProduct = triggerBottom

  if (window.matchMedia('(min-width:' + bpTab + 'px)').matches) {
    //タブレット以上
    topProduct = productContainer.offset().top - headerHeight + paddingTop + 56
  }
  if (window.matchMedia('(min-width:' + bpTabWide + 'px)').matches) {
    //タブレット横置き以上
    bottomProduct = topProduct + productContainer.height() - paddingBottom - imgHeight - 200
  }
  if (window.matchMedia('(min-width:' + bpPC + 'px)').matches) {
    //PC以上
    bottomProduct = topProduct + productContainer.height() - paddingBottom - imgHeight
  }

  // $(document).on('scroll', function () {
  //   var alto_total = $(this).scrollTop()
  //   var topProduct__img = $('.topProduct__img').offset()
  //   var topProductDetail__list = $('.topProductDetail__list').offset()
  //   console.log(alto_total + ' == ' + topProduct__img.top)
  //   if (alto_total >= topProduct__img.top) {
  //     console.log('active')
  //     $('.topProduct__img').addClass('active')
  //   }
  //   console.log(topProductDetail__list.top)
  //   if (topProductDetail__list.top <= topProduct__img.top) {
  //     $('.topProduct__img').addClass('bottom')
  //   }
  //   console.log($('.topProduct__img').hasClass('bottom'))
  //   if (topProductDetail__list.top > topProduct__img.top && $('.topProduct__img').hasClass('bottom') == true) {
  //     // $('.topProduct__img').removeClass('bottom')
  //     // console.log('no')
  //   }
  // })

  let distance = 0
  // console.log('topProduct: ' + topProduct)
  console.log('bpTabWide: ' + bpTabWide)
  console.log('bottomProduct: ' + bottomProduct)

  $(document).on('scroll', function () {
    distance = $(this).scrollTop()
    console.log('distance: ' + distance)
    if (topProduct <= distance) {
      $('.js-topProduct').addClass('active')
    } else {
      $('.js-topProduct').removeClass('active')
    }
    if (bottomProduct <= distance) {
      $('.js-topProduct').removeClass('active')
      $('.js-topProduct').addClass('bottom')
    } else {
      if (topProduct <= distance) {
        $('.js-topProduct').addClass('active')
      }
      $('.js-topProduct').removeClass('bottom')
    }
  })
}

/*
          ######    ###     ######  ########
         ##       ##   ##  ##       ##
#######  ##      ##     ##  ######  ######
         ##      #########       ## ##
          ###### ##     ##  ######  ########
*/
$('.js-topCase').on('mouseover', function () {
  const src = $('.js-topCaseImg img').attr('src')
  const oldNo = src.slice(-6)
  const newNo = $(this).attr('data-src') + '.jpg'
  $('.js-topCaseImg img').attr('src', src.replace(oldNo, newNo))
})

if (window.matchMedia('(min-width:' + bpTab + 'px)').matches) {
  //タブレット以上
  $('.js-topConsideration').on('mouseover', function () {
    $(this).siblings().addClass('hide')
  })
  $('.js-topConsideration').on('mouseleave', function () {
    $(this).siblings().removeClass('hide')
  })
}

/*
 ######  ##       #### ########  ########
##       ##        ##  ##     ## ##
 ######  ##        ##  ##     ## ######
      ## ##        ##  ##     ## ##
 ######  ######## #### ########  ########
*/
/*
        ########  #######  ########          ##     ## ##     ##
           ##    ##     ## ##     ##         #### #### ##     ##
#######    ##    ##     ## ########  ####### ## ### ## ##     ##
           ##    ##     ## ##                ##     ##  ##   ##
           ##     #######  ##                ##     ##    ###
*/
if ($('.js-topMv')[0]) {
  const textSubSlideName = '.js-topMv-sub'
  // eslint-disable-next-line no-unused-vars
  const topMvSub = new Swiper(textSubSlideName, {
    speed: 500,
    createElements: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      // when window width is >= 769px
      769: {},
      // when window width is >= 1024px
      1024: {},
      // when window width is >= 1200px
      1200: {},
    },
  })
  const textSlideName = '.js-topMv'
  // eslint-disable-next-line no-unused-vars
  const topMv = new Swiper(textSlideName, {
    speed: 500,
    createElements: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      // when window width is >= 769px
      769: {},
      // when window width is >= 1024px
      1024: {},
      // when window width is >= 1200px
      1200: {},
    },
  })
  topMv.controller.control = [topMvSub]
  // topMvSub.controller.control = [topMv]
}

/*
        ########  #######  ########           ######    ###    ##     ## ######## ########     ###
           ##    ##     ## ##     ##         ##       ##   ##  #### #### ##       ##     ##  ##   ##
#######    ##    ##     ## ########  ####### ##      ##     ## ## ### ## ######   ########  ##     ##
           ##    ##     ## ##                ##      ######### ##     ## ##       ##   ##   #########
           ##     #######  ##                 ###### ##     ## ##     ## ######## ##     ## ##     ##
*/
if ($('.js-topCameraSlide')[0]) {
  const textSlideName = '.js-topCameraSlideText'
  // eslint-disable-next-line no-unused-vars
  const topCameraSlideText = new Swiper(textSlideName, {
    speed: 1000,
    createElements: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    breakpoints: {
      // when window width is >= 769px
      769: {},
      // when window width is >= 1024px
      1024: {},
      // when window width is >= 1200px
      1200: {
        loopAdditionalSlides: 1,
      },
    },
  })
  const slideName = '.js-topCameraSlide'
  // eslint-disable-next-line no-unused-vars
  const topCameraSlide = new Swiper(slideName, {
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      scale: 0.8,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    speed: 1000,
    createElements: true,
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 147,
    watchSlidesProgress: true,
    thumbs: {
      swiper: topCameraSlideText,
    },
    breakpoints: {
      // when window width is >= 769px
      769: {},
      // when window width is >= 1024px
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 147,
      },
      // when window width is >= 1200px
      1200: {
        loopAdditionalSlides: 1,
        slidesPerView: 'auto',
        spaceBetween: 147,
      },
    },
    navigation: {
      nextEl: slideName + '-next',
      prevEl: slideName + '-prev',
    },
  })

  if (window.matchMedia('(min-width:' + bpPC + 'px)').matches) {
    // マウスストーカー関連の要素（任意で変更してください）
    const mouseStalker = '.js-topCameraSlide-cursor' // マウスストーカーになる要素を指定
    const mouseTargetPrev = '.js-topCameraSlide-prev' // リンクなどアクションを付けたい要素を指定
    const mouseTargetNext = '.js-topCameraSlide-next' // リンクなどアクションを付けたい要素を指定
    const mouseStalkerArea = window // マウスストーカーが機能する要素を指定
    // const mouseStalkerArea = '.js-topCameraSlide' // マウスストーカーが機能する要素を指定

    // 処理で使う変数たち
    const stkrSize = parseInt($(mouseStalker).css('width').replace(/px/, ''))
    const stkrPosX = parseInt($(mouseStalker).css('left').replace(/px/, ''))
    const cssPosAjust = stkrPosX + stkrSize / 2

    // 追従用の処理
    $(mouseStalkerArea).hover(function () {
      $(mouseStalkerArea).mousemove(function (e) {
        let x = e.clientX - cssPosAjust
        let y = e.clientY - cssPosAjust
        $(mouseStalker).css({
          transform: 'translate(' + x + 'px,' + y + 'px)',
        })
      })
    })

    // リンクホバーの処理
    $(mouseTargetPrev).hover(
      function (e) {
        $(mouseStalker).addClass('active')
        $(mouseStalker).text('PREV')
      },
      function () {
        $(mouseStalker).removeClass('active')
        $(mouseStalker).text('')
      }
    )
    $(mouseTargetNext).hover(
      function (e) {
        $(mouseStalker).addClass('active')
        $(mouseStalker).text('NEXT')
      },
      function () {
        $(mouseStalker).removeClass('active')
        $(mouseStalker).text('')
      }
    )
  }
}

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

$('.js-ques').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
})

$('.back2top').on('click', function () {
  $('html, body').animate({ scrollTop: 0 }, 1000)
})

$(document).on('change', 'select[name="howto_know"]', function (e) {
  $('input[name="other_entry"]').closest('.contactForm__line').removeClass('show')
  if ($(this).val() === 'その他') {
    $('input[name="other_entry"]').closest('.contactForm__line').addClass('show')
  }
})

$(window).on('load', function () {
  let howto_know = $('input[type="hidden"][name="howto_know"]').val()
  if ($('select[name="howto_know"]').val() === 'その他' || howto_know === 'その他') {
    $('input[name="other_entry"]').closest('.contactForm__line').addClass('show')
  } else {
    $('input[type="hidden"][name="other_entry"]').val('')
  }
})

$(function () {
  $('.mw_wp_form').find('form').attr('autocomplete', 'off')
  var $btns = $('.js_filter').on('click', function () {
    if (this.id == 'all') {
      $('.productArchiveList > li').fadeIn(450)
    } else {
      var $el = $('.' + this.id).fadeIn(450)
      $('.productArchiveList > li').not($el).hide()
    }
    $btns.removeClass('active')
    $(this).addClass('active')
  })
})

/*
        ########  #######  ########          ##     ##  #######   ##   ######  ######
           ##    ##     ## ##     ##         ##     ## ##     ##  ##  ##       ##
#######    ##    ##     ## ########  ####### ##     ## ##     ##  ##  ##       #####
           ##    ##     ## ##                 ##   ##  ##     ##  ##  ##       ##
           ##     #######  ##                   ###     #######   ##   ######  ######
*/
if ($('.js_voice')[0]) {
  const topVoice = new Swiper('.js_voice', {
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: '.voice-button-next',
      prevEl: '.voice-button-prev',
    },
    breakpoints: {
      // when window width is >= 769px
      769: {
        slidesPerView: 2.6,
        spaceBetween: 40,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 2.8,
        spaceBetween: 40,
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 4.8,
        spaceBetween: 40,
      },
    },
  })
}
